@if(internalPagedMessages != null) {
    <table mat-table [dataSource]="dataSource">
        
        <ng-container matColumnDef="unread">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"><mat-icon *ngIf="element.timeFirstRead == null && !element.fromClient">mark_email_unread</mat-icon></td>
        </ng-container>
        
        <ng-container matColumnDef="subject">
            <th mat-header-cell *matHeaderCellDef>Subject</th>
            <td mat-cell *matCellDef="let element">{{element.subject}}</td>
        </ng-container>
        @if(isSearchPage()){
        <ng-container matColumnDef="folder">
            <th mat-header-cell *matHeaderCellDef>Folder</th>
            <td mat-cell *matCellDef="let element">{{getFolderName(element)}}</td>
        </ng-container>
        }
        <ng-container matColumnDef="received">
            <th mat-header-cell *matHeaderCellDef>{{getReceivedColumnName()}}</th>
            <td mat-cell *matCellDef="let element">{{element.timeSent | dateTimeFromIso | dateTimeToFormat: 'MMM dd, yyyy, HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="attachment">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"><mat-icon *ngIf="element.numberOfAttachments > 0 || element.onlineQuestionnaireId != null">attach_file</mat-icon></td>
        </ng-container>

        <ng-container matColumnDef="link">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"><mat-icon>chevron_right</mat-icon></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.unread]="row.timeFirstRead == null && !row.fromClient" [routerLink]="getCloseViewMessageRouterLink(row)"></tr>
    </table>
    

    <div class="text-align-center m-t-1" *ngIf="internalPagedMessages.items.length === 0">There are currently no messages here.</div>
}